import React from 'react';
import { Product } from 'types/Product';
import { ProductBlockContainer, RelatedProductsContainer, RelatedProductsTitle } from '../styled';
import './styles.css';
import { ProductBlock } from './ProductBlock';

interface RelatedProductsProps {
  products: Product[];
  size: string;
}

export const RelatedProductsBySize = ({ 
  products,
  size
}: RelatedProductsProps): React.JSX.Element => {    
  if (!products || products.length < 3) {
    return null;
  }

  const relatedProductsTitle = `${size} Options You May Also Like`;

  return (
    <RelatedProductsContainer className="related-by-size">
      <RelatedProductsTitle secondary className="related-by-size-title">{relatedProductsTitle}</RelatedProductsTitle>
      <ProductBlockContainer className="related-by-size-container">
        {products.map((product: Product) => (
            <ProductBlock key={product.sku} product={product} size={size}/>
        ))}
      </ProductBlockContainer>
    </RelatedProductsContainer>
  );
};
